import { markSidebarItemStateButtons } from '@/core/support_gui_components/sidebar/sidebar'

export function getCurrentUrlParameters () {
	var search = window.location.search.substr(1)
	var keys = {}
	search.split('&').forEach(function (item) {
		item = item.split('=')
		keys[item[0]] = item[1]
	})
	return keys
}

export function getLocale () {
	return window.locale
}

export function getLocalizedMessage (msg) {
	var localized = i18n.t(msg)
	if (localized === undefined || localized === null) {
		console.log('Not found localized string for: ', msg)
		return msg
	}
	return localized
}

export function showNextTab (direction) {
	if ($('#tab-header').css('display') == 'none') {
		return
	} //if Tabs are disabled

	var tabCount = $('.tab-content').find('.tab-pane').length
	$('.tab-content').find('.tab-pane').eq(document.activeTabIndex).attr('class', 'tab-pane fade')
	$('#groups').children().eq(document.activeTabIndex).attr('class', '')
	document.activeTabIndex = (tabCount + document.activeTabIndex + direction) % tabCount
	$('.tab-content').find('.tab-pane').eq(document.activeTabIndex).addClass('in active')
	$('#groups').children().eq(document.activeTabIndex).addClass('active')
	document.body.focus()
}

export function removeTabindex () {
	var inputForms = $('body').find('input, textarea, button, a')
	inputForms.each(function () {
		if (!$(this).hasClass('attribute-editor')) {
			$(this).attr('tabindex', '-1')
		}
	})
}

export function setDisabledState (selector, disabled) {
	$(selector).prop('disabled', disabled)
}

export function disableLockableEditorsWithDefaultValues () {
	$('div .row .def-lock').prop('disabled', true)
}

export function openNewTab (url) {
	window.open(url, '_blank')
}

export function copyObject (obj, recursive) {
	return _.isArray(obj) ? $.extend(recursive, [], obj) : $.extend(recursive, {}, obj)
}

export function booleanStringValueToLogicalBoolean (stringValue) {
	return (stringValue == 'true')
}

export function isCorrectData (data) {
	if (_.isNaN(data) || _.isNull(data) || _.isUndefined(data) || data == 'any' || data === '') {
		return false
	} else {
		return true
	}
}

var localStorageSpace = function(){
	var allStrings = '';
	for(var key in window.localStorage){
		if(window.localStorage.hasOwnProperty(key)){
			allStrings += window.localStorage[key];
		}
	}
	return allStrings ? 3 + ((allStrings.length*16)/(8*1024)) + ' KB' : 'Empty (0 KB)';
};

export function loadConfig (key) {
	var resultHolder = {}
	$.ajax({
		url: window.urlContext + 'user-config/get',
		type: 'POST',
		context: resultHolder,
		dataType: 'json',
		data: { key: key },
		async: true,
		success: function (data) {
			this['data'] = data
		}
	})
	return resultHolder['data']
}

export function saveConfig (key, value) {
	$.ajax({
		url: window.urlContext + 'user-config/set',
		type: 'POST',
		dataType: 'json',
		data: {
			key: key,
			value: value
		},
		async: true,
		success: function (data) {
			localStorage.setItem(key, value)
		}
	})
}

//clear selection for Chrome, Firefox and IE
export function clearSelection () {
	if (window.getSelection) {
		if (window.getSelection().empty) {
			window.getSelection().empty()
		} else if (window.getSelection().removeAllRanges) {
			window.getSelection().removeAllRanges()
		}
	} else if (document.selection) {
		document.selection.empty()
	}
}

export function createTooltip (selector, title, place, container) {
	$('#' + selector).tooltip({
		placement: place,
		container: container || 'body',
		title: title
	})
}

export function getPageData (url) {
	var pageData = {}

	$.ajax({
		type: 'POST',
		url: url + '/initial-data',
		async: false,

		success: function (data) {
			pageData = data
		},
		error: function () {
			showMessageAlert(getLocalizedMessage('error'), getLocalizedMessage('error.loading.data'), 'danger')
		}
	})

	return pageData
}

export function getAttributeNameWithoutPostfix (name) {
	if (name) {
		var postfixStart = name.indexOf('__')
		return postfixStart > 0 ? name.substring(0, postfixStart) : name
	}
}

export function onSuccessItemDataSave () {
	markSidebarItemStateButtons(false)
}

export function checkPassword (password, confirmation, wrongAction) {
	var result = true

	if (password.length < 8) {
		showPasswordError(getLocalizedMessage('password.must.be.at.least.8.characters'))
		result = false
		if (wrongAction) {
			wrongAction()
		}
	} else if (password !== confirmation) {
		showPasswordError(getLocalizedMessage('passwords.dont.match'))
		result = false
		if (wrongAction) {
			wrongAction()
		}
	}

	return result

	function showPasswordError (message) {
		showMessageAlert(message, 'danger')
	}
}

export function getFormattedDateTime (date) {
	return getFormattedDate(date) + ' ' + getFormattedTime(date)
}

export function getFormattedDate (date) {
	return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) +
		'-' + ('0' + date.getDate()).slice(-2)
}

export function getFormattedTime (date) {
	return ('0' + (date.getHours())).slice(-2) +
		':' + ('0' + date.getMinutes()).slice(-2) +
		':' + ('0' + date.getSeconds()).slice(-2)
}

export function isCharacterJqueryKeyCode (code) {
	return code != 27 /*esc*/ && !(code > 111 && code < 124) /*f1-f12*/ && code != 45 /*ins*/ && code != 46 /*del*/
		&& code != 36 /*home*/ && code != 35 /*end*/ && code != 34 /*pgdown*/ && code != 33 /*pgup*/
		&& code != 8 /*backspace*/ && code != 9 /*tab*/ && code != 20 /*capslock*/ && code != 13 /*enter*/
		&& code != 16 /*shift*/ && code != 17 /*ctrl*/ && code != 91 /*start*/ && code != 18 /*alt*/
		&& code != 93 /*menu*/ && !(code > 36 && code < 41) /*arrows (L-U-R-D)*/ && code != 144 /*numlock*/
}

export function showMessageAlert (title, status, content) {
	UIkit.notification({
		message: title + ' ' + (content ? content : ''),
		status: status,
		pos: 'top-right',
		timeout: 4000
	})
}

export function bindModalCloseConfirmation (selector) {
	selector.off('hide.bs.modal')
	selector.on('hide.bs.modal', function (event) {
		event.preventDefault()
		Swal.fire({
			title: getLocalizedMessage('do.you.want.close.modal.window'),
			showCancelButton: true,
			confirmButtonText: getLocalizedMessage('yes'),
			cancelButtonText: getLocalizedMessage('no'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			}
		}).then(function (result) {
			console.log(result)
			if (result.value) {
				selector.off('hide.bs.modal')
				selector.modal('hide')
			} else {
				return false
			}
		})
	})
}

export function emailValidation (email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	return re.test(email)
}

export function saveAttributes (data, type) {
	if (!type) {
		type = 'ATTRIBUTES_GROUPS'
	}

	if (data) {
		var formData = new FormData()
		var blob = new Blob([JSON.stringify(data)], { type: 'application/json' })
		var file = new File([blob], type.toLowerCase() + '.json', {
			type: 'application/json',
			lastModified: new Date()
		})
		formData.append('source', file)

		$.ajax({
			url: window.urlContext + 'company-attributes-config/' + companyId + '/' + type,
			data: formData,
			cache: false,
			contentType: false,
			processData: false,
			type: 'POST',
			async: true,

			success: function () {
				var modalWindowSelector = $('.modal-window')
				modalWindowSelector.off('hide.bs.modal')
				modalWindowSelector.modal('hide')
				showMessageAlert(getLocalizedMessage('changes.saved'), 'success')
			},
			error: function (jqXHR, textStatus, errorThrown) {
				var message = getLocalizedMessage('error.saving')
				if (jqXHR.status === 400) {
					message += '\n' + jqXHR.responseText
				}
				showMessageAlert(message, 'danger')

				var modalWindowSelector = $('.modal-window')
				modalWindowSelector.off('hide.bs.modal')
				modalWindowSelector.modal('hide')
			}
		})
	}
}

export function CopyToClipboard (attributeName, that) {
	event.preventDefault()
	if (that) {
		var lang = $(that).attr('value') || $(that).parent().find('label').attr('value')
		attributeName = '{' + attributeName + '__' + lang + '}'
	}
	if (navigator.clipboard) {
		navigator.clipboard.writeText(attributeName)
	} else {
		var textField = document.createElement('textarea')
		textField.innerText = attributeName
		document.body.appendChild(textField)
		textField.select()
		document.execCommand('copy')
		textField.remove()
	}
}

export function countriesListHtml (countries, vm) {
	let html = []
	let selected = ""
	for (let val in countries) {
		selected = (val === "EE") ? " selected " : " "
		html.push('<option' + selected + 'value="' + val + '"> ' + vm.$t(countries[val]) + ' </option>')
	}
	return html.join('')
}

export function getLocaleFromUrl () {
	var lang = {
		'ee': 'Estonian',
		'en': 'English',
		'lt': 'Lithuanian',
		'lv': 'Latvian',
		'ru': 'Русский',
	}

	var locale = window
		.location
		.search
		.replace('?', '')
		.split('&')
		.reduce(
			function (p, e) {
				var a = e.split('=')
				p[decodeURIComponent(a[0])] = decodeURIComponent(a[1])
				return p
			},
			{}
		)

	return {
		title: lang[(locale['lang'] || 'en')],
		code: locale['lang'] || 'en'
	}
}
